import { DateTime } from 'luxon';

import { Sprint } from '@/tracker/types';

export const formatDates = ({ startDate, endDate }: Sprint) =>
  `${DateTime.fromISO(startDate).toFormat('dd.MM')} – ${DateTime.fromISO(endDate).toFormat('dd.MM')}`;
